<template>
    <NuxtLayout name="bio-tools-manual">
        <div class="manual-container container">
            <h1 v-html="$t('BioTools.AsoTool.Manual.Title')"></h1>

            <section>
                <h2 v-html="$t('BioTools.AsoTool.Manual.Section1')"></h2>
                <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript11')"></div>
                <div class="summarys">
                    <div class="summarys-container">
                        <div class="summary-items">
                            <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript12')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript13')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript14')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript15')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript16')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript17')"></div>
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript18')"></div>
                            <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript19')"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <h2 v-html="$t('BioTools.AsoTool.Manual.Section2')"></h2>
                <h3 style="margin-top: 0" v-html="$t('BioTools.AsoTool.Manual.Module21')"></h3>

                <div class="summarys">
                    <div class="summarys-container">
                        <div class="summary-items">
                            <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript21')"></div>
                        </div>
                    </div>
                </div>

                <div class="summarys">
                    <div class="summarys-title" @click="summary2 = !summary2" :class="{ active: !summary2 }">
                        <div class="summarys-icon"></div>
                        <h4 v-html="$t('BioTools.AsoTool.Manual.Summary21')"></h4>
                    </div>

                    <div class="summarys-container" v-show="summary2">
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript22')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript23')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript24')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript25')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript26')"></div>
                    </div>

                    <div class="summarys-container" v-show="summary2" style="margin-top: 36px">
                        <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript27')"></div>
                        <img v-if="i18n.locale.value === 'en'" src="@/assets/images/bio-tools/aso-tool/en/manual/summary1.png" class="summary-img" />
                        <img v-else src="@/assets/images/bio-tools/aso-tool/zh/manual/summary1.png" class="summary-img" />
                    </div>
                </div>

                <div class="summarys">
                    <div class="summarys-title" @click="summary3 = !summary3" :class="{ active: !summary3 }">
                        <div class="summarys-icon"></div>
                        <h4 v-html="$t('BioTools.AsoTool.Manual.Summary22')"></h4>
                    </div>

                    <div class="summarys-container" v-show="summary3">
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript28')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript29')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript210')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript211')"></div>
                    </div>

                    <div class="summarys-container" v-show="summary3" style="margin-top: 36px">
                        <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript212')"></div>
                        <img v-if="i18n.locale.value === 'en'" src="@/assets/images/bio-tools/aso-tool/en/manual/summary2.png" class="summary-img" />
                        <img v-else src="@/assets/images/bio-tools/aso-tool/zh/manual/summary2.png" class="summary-img" />
                    </div>
                </div>
            </section>

            <section>
                <h2 v-html="$t('BioTools.AsoTool.Manual.Section3')"></h2>
                <div class="descript" v-html="$t('BioTools.AsoTool.Manual.Descript31')"></div>

                <div class="summarys">
                    <div class="summarys-container">
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript32')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript33')"></div>
                        <img v-if="i18n.locale.value === 'en'" src="@/assets/images/bio-tools/aso-tool/en/manual/summary3.png" class="summary-img" />
                        <img v-else src="@/assets/images/bio-tools/aso-tool/zh/manual/summary3.png" class="summary-img" />
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript34')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript35')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript36')"></div>
                        <div class="summary-item" v-html="$t('BioTools.AsoTool.Manual.Descript37')"></div>
                        <img v-if="i18n.locale.value === 'en'" src="@/assets/images/bio-tools/aso-tool/en/manual/summary4.png" class="summary-img" />
                        <img v-else src="@/assets/images/bio-tools/aso-tool/zh/manual/summary4.png" class="summary-img" />
                    </div>
                </div>
            </section>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
const i18n = useI18n();

const summary2 = ref<boolean>(true);
const summary3 = ref<boolean>(true);
</script>

